import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import './AuthForm.css';

export default function RegisterPage() {
    const [step, setStep] = useState(1); // 1: Sign Up, 2: Confirm Code
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [confirmationCode, setConfirmationCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSignUp = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await authService.signUp(username, password, email);
            setStep(2); // Move to confirmation step
        } catch (err) {
            setError(err.message || "Registration failed.");
        } finally {
            setLoading(false);
        }
    };

    const handleConfirm = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await authService.confirmSignUp(username, confirmationCode);
            // Success! Redirect to login
            navigate('/login');
            alert("Account verified! You can now log in.");
        } catch (err) {
            setError(err.message || "Verification failed. Check your code.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-form">
                {step === 1 ? (
                    <>
                        <h1 className="auth-title">Register</h1>
                        {error && <p className="auth-error">{error}</p>}
                        <form onSubmit={handleSignUp}>
                            <input
                                type="text"
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                className="auth-input"
                            />
                            <input
                                type="email"
                                placeholder="Email (for verification)"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="auth-input"
                            />
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="auth-input"
                            />
                            <button type="submit" className="auth-button" disabled={loading}>
                                {loading ? "Creating Account..." : "Next"}
                            </button>
                        </form>
                    </>
                ) : (
                    <>
                        <h1 className="auth-title">Verify Email</h1>
                        <p style={{ textAlign: 'center', marginBottom: '15px' }}>We sent a code to your email.</p>
                        {error && <p className="auth-error">{error}</p>}
                        <form onSubmit={handleConfirm}>
                            <input
                                type="text"
                                placeholder="Verification Code"
                                value={confirmationCode}
                                onChange={(e) => setConfirmationCode(e.target.value)}
                                required
                                className="auth-input"
                            />
                            <button type="submit" className="auth-button" disabled={loading}>
                                {loading ? "Verifying..." : "Confirm & Finish"}
                            </button>
                        </form>
                    </>
                )}

                <p className="auth-link">
                    Already have an account? <Link to="/login">Login</Link>
                </p>
            </div>
        </div>
    );
}